import React, { useState } from "react";
import styles from "./payout.module.css";
import { Box, TablePagination, Typography } from "@mui/material";
import TransactionFilter from "../TransactionFilter/TransactionFilter";
import { Pagination } from "antd";
import Notificatio from "../Notification/BulkNotification";
import PayoutModal from "./PayoutModal";
import { useNavigate } from "react-router-dom";

const BulkPayoutsTable = ({ data, setUploadedFiles }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(8);
  const [continuePayout, setContinue] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0); // Reset to first page
  };

  const paginatedData = data.data.slice(
    currentPage * pageSize,
    (currentPage + 1) * pageSize
  );

  const columnExists = (col) =>
    data.data.length > 0 && Object.keys(data.data[0]).includes(col);
  console.log("data--->", paginatedData);

  return (
    <Box mt={4}>
      <div className="w-75">
        <Box
          display="flex"
          justifyContent="space-around"
          p={2}
          sx={{ border: "1px solid #E0E0E0", borderRadius: "10px" }}
        >
          <Box textAlign="center">
            <img
              src="/coins-stacked-03.svg"
              alt="coin-stacked
            "
            />
          </Box>

          <Box textAlign="center">
            <Typography variant="h6" fontWeight="bold">
              {data.data.length}
            </Typography>
            <Typography fontSize="14px">Total payout uploaded</Typography>
          </Box>
          <Box height="40px" borderLeft="1px solid #E0E0E0" />
          <Box textAlign="center">
            <Typography variant="h6" fontWeight="bold">
              12
            </Typography>
            <Typography fontSize="14px">Payout details are valid</Typography>
          </Box>
          <Box height="40px" borderLeft="1px solid #E0E0E0" />
          <Box textAlign="center">
            <Typography variant="h6" fontWeight="bold" color="#B66C66">
              0
            </Typography>
            <Typography fontSize="14px">Payout details have errors</Typography>
          </Box>
        </Box>
      </div>
      <div className={`${styles.root} mt-2`}>
        <section className={styles.transactionDataTable}>
          <div className={styles.top}>
            <div className={styles.reportHeader}>
              <h3 className={styles.latestAccountTransaction}>
                Failed payout details
              </h3>
            </div>
            <div className={styles.headerSeparator} />
          </div>
          <div className={styles.reportTable}>
            <div className={styles.tableHeader}>
              <div className={styles.cell}>Row</div>
              <div className={styles.cell}>Beneficiary Name</div>
              <div className={styles.cell}>Mode</div>

              {columnExists("A/c no") && (
                <div className={styles.cell}>Account NO</div>
              )}
              {columnExists("IFSC") && <div className={styles.cell}>IFSC</div>}
              {columnExists("UPI id") && (
                <div className={styles.cell}>UPI ID</div>
              )}

              <div className={styles.cell}>Amount (₹)</div>
              <div className={styles.cell}>Transaction Note</div>
              <div className={styles.cell}>Internal Note</div>
              <div className={styles.cell}>Reason for Error</div>
            </div>

            {paginatedData.map((row, index) => (
              <div className={styles.tableRow} key={index + 1}>
                <div className={styles.cell}>
                  {currentPage * itemsPerPage + index + 1}
                </div>
                <div className={styles.cell}>{row["Beneficiary name"]}</div>
                <div className={styles.cell}>{row["Mode"]}</div>

                {columnExists("A/c no") && (
                  <div className={styles.cell}>{row["A/c no"]}</div>
                )}
                {columnExists("IFSC") && (
                  <div className={styles.cell}>{row["IFSC"]}</div>
                )}
                {columnExists("UPI id") && (
                  <div className={styles.cell}>{row["UPI id"]}</div>
                )}

                <div className={styles.cell}>{row["Amount"]}</div>
                <div className={styles.cell}>{row["Transaction note"]}</div>
                <div className={styles.cell}>{row["Internal note"]}</div>
                <div className={styles.cell}>
                  <span
                    className="d-flex mousePointer"
                    onClick={() => setShowModal(true)}
                  >
                    <img className="mx-2" src="/viewIcon.svg" />
                    View
                  </span>
                </div>
              </div>
            ))}

            <TablePagination
              component="div"
              count={data.data.length}
              page={currentPage}
              onPageChange={handlePageChange}
              rowsPerPage={itemsPerPage}
              onRowsPerPageChange={handleRowsPerPageChange}
              rowsPerPageOptions={[5, 8, 10, 20]}
            />
          </div>
        </section>
      </div>

      <div className="d-flex gap-2 mt-3 mb-3">
        <button
          onClick={() => setUploadedFiles([])}
          className={`${styles.templateButton} w-25 p-2 mb-3`}
        >
          <div>Reupload Template</div>
        </button>
        <button
          className={`${styles.continueButton} w-25 p-2 mb-3`}
          onClick={() => setContinue(true)}
        >
          <div>Continue</div>
        </button>
      </div>
      {continuePayout && (
        <div className={styles.Notification}>
          <Notificatio
          // isVisible={dataUpdated}
          // completeData={completeData.length}
          // incompleteData={incompleteRows.length}
          // duplicateUsers={duplicateUsers}
          // onClose={() => setDataUpdated(false)}
          />
        </div>
      )}
      {showModal && <PayoutModal onClose={() => setShowModal(false)} />}
    </Box>
  );
};

export default BulkPayoutsTable;
